<template>
  <div class="account-hero-section">
    <div class="hero-content">
      <div class="hero-text">
        <h1 class="hero-title">
          <span class="subtitle">Discover the World's Currencies,</span>
          <span class="golden-text">Unveil Global Opportunities</span>
        </h1>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountHero'
}
</script>

<style>
.account-hero-section {
  height: 60vh;
  min-height: 400px;
  background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
              url('/wp-content/uploads/2024/02/BG-Akun.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.hero-content {
  max-width: 1200px;
  width: 100%;
  padding: 0 60px;
  text-align: center;
}

.hero-text {
  color: white;
  max-width: 800px;
  margin: 0 auto;
}

.hero-title {
  margin: 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  line-height: 1.2;
}

.subtitle {
  display: block;
  font-size: 1.5rem;
  font-weight: 400;
  color: white;
  margin-bottom: 0.5rem;
}

.golden-text {
  color: #D4AF37;
  display: block;
  font-size: 3.5rem;
  font-weight: 700;
}

/* Responsive design */
@media (max-width: 768px) {
  .golden-text {
    font-size: 2.5rem;
  }

  .subtitle {
    font-size: 1.2rem;
  }

  .hero-content {
    padding: 0 40px;
  }

  .account-hero-section {
    height: 50vh;
    min-height: 350px;
  }
}

@media (max-width: 480px) {
  .golden-text {
    font-size: 2rem;
  }

  .subtitle {
    font-size: 1rem;
  }

  .hero-content {
    padding: 0 20px;
  }

  .account-hero-section {
    height: 45vh;
    min-height: 300px;
  }
}
</style>